<template>
  <div class="main-content">
    <SectionTitle class="animate-target" v-animate-in :title="title"></SectionTitle>
    <div class="cnt-text animate-target" v-animate-in>MR overactivation can cause organ damage and dysfunction in the heart and kidneys<sup>1-3</sup></div>
    <img class="cnt-image animate-target" v-animate-in src="../../assets/images/p3-2/3-2-1.png" />
    <div class="cnt-text animate-target" v-animate-in>Finerenone is the first and only non-steroidal MRA approved to treat CKD and T2D<sup>1</sup></div>
    <img class="cnt-image animate-target" v-animate-in src="../../assets/images/p3-2/3-2-2.png" />
    <GoNext class="animate-target" v-animate-in href="/section3/3-3">Next</GoNext>
    <ContentNotice class="animate-target" v-animate-in :txt="noticeTxt"/>
  </div>
</template>

<script>
import SectionTitle from "../../components/SectionTitle";
import GoNext from "../../components/GoNext";
import ContentNotice from "../../components/ContentNotice";
import {mapState} from "vuex";
export default {
  name: "s3-2",
  components: {SectionTitle, GoNext, ContentNotice},
  computed:{
  },
  data(){
    return{
      noticeTxt:"CKD, chronic kidney disease; CV, cardiovascular; MR, mineralocorticoid receptor; MRA, mineralocorticoid receptor antagonist; T2D, type 2 diabetes.<br/><div class='brs'></div>"
      +"References:<br/><div class='brs'></div>"
      +"1. Jaisser F, <i>et al. Pharmacol Rev</i>. 2016;68(1):49-75. doi:10.1124/pr.115.011106.<br/>"
      +"2. Bauersachs J, <i>et al. Hypertension</i>. 2015;65(2):257-263. doi:10.1161/HYPERTENSIONAHA.114.04488.<br/>"
      +"3. Kolkhof P, <i>et al. Pharmacol Res</i>. 2021;172:1-13. doi:10.1016/j.phrs.2021.105859.<br/>"
      +"4. KERENDIA Product Information.",
      title:"How does the nonsteroidal MRA, finerenone, work?"
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/section3/s3.css";
.cnt-text {
  color: #10384F;
  font-size: 24px;
  font-weight: 500;
  margin-top:40px;
}
.cnt-image {
  width: 100%;
  margin-top: 40px;
}
</style>
